import { render, staticRenderFns } from "./ProviderCompetitionPage.vue?vue&type=template&id=0150328c&scoped=true"
import script from "./ProviderCompetitionPage.vue?vue&type=script&lang=js"
export * from "./ProviderCompetitionPage.vue?vue&type=script&lang=js"
import style0 from "./ProviderCompetitionPage.vue?vue&type=style&index=0&id=0150328c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150328c",
  null
  
)

export default component.exports